import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './components/About';
import Stories from './components/Stories';
import Projects from './components/Projects';
import ProjectDetails from './components/ProjectDetails';
import PrivacyPolicy from './components/PrivacyPolicy';
import axios from 'axios';



function App() {

  useEffect(() => {
  
    const incrementViewCount = async () => {
      try {
        await axios.post('https://leoleveque.net/api/increment-view');
      } catch (error) {
        console.error('Error incrementing view count:', error);
      }
    };

    incrementViewCount();
  }, []); 

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <div className="App">
              <About />
              <Stories /> 
              <Projects />
            </div>
          } />
        <Route path="/projects/:projectId" element={<ProjectDetails />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
      <footer>
          <p>
              <a href="/privacy-policy">Privacy Policy</a> | &copy; 2024 Léo Lévêque - All rights reserved.
          </p>
      </footer>
    </Router>
    
  );
}

export default App;
